export const servicesData = [
  {
    icon: 'ri-palette-line',
    title: 'Branding',
    description: 'Transform your brand identity with embedded fractional brand leaders who work directly within your organization to build authentic, differentiated positioning that resonates with your target audience.',
    features: [
      'Fractional Chief Brand Officers embedded in your team',
      'Brand strategy and identity development',
      'Positioning and messaging frameworks',
      'Brand architecture and guidelines'
    ]
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Marketing',
    description: 'Deploy experienced marketing leaders who integrate seamlessly into your operations, building scalable marketing systems and driving measurable growth through hands-on execution.',
    features: [
      'Fractional CMOs and marketing directors',
      'Growth strategy and execution',
      'Marketing automation and tech stack',
      'Performance-driven campaign management'
    ]
  },
  {
    icon: 'ri-code-box-line',
    title: 'Technology',
    description: 'Embed senior technology leaders who architect and implement solutions directly within your team, ensuring seamless integration and knowledge transfer for long-term success.',
    features: [
      'Fractional CTOs and technical architects',
      'Technology stack optimization',
      'Digital infrastructure development',
      'Technical team leadership and mentoring'
    ]
  },
  {
    icon: 'ri-shopping-cart-line',
    title: 'Commerce',
    description: 'Place commerce experts directly into your organization to build and optimize revenue-generating systems, from e-commerce platforms to sales operations and customer acquisition.',
    features: [
      'Fractional commerce leaders embedded',
      'E-commerce platform strategy and execution',
      'Conversion optimization and UX',
      'Revenue operations and analytics'
    ]
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Experience',
    description: 'Integrate customer experience leaders who work alongside your team to design and implement exceptional user journeys that drive loyalty and sustainable growth.',
    features: [
      'Fractional CX officers in your organization',
      'Customer journey mapping and optimization',
      'User research and testing programs',
      'Experience design and implementation'
    ]
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Sales',
    description: 'Deploy proven sales leaders who become part of your team, building high-performing sales organizations, optimizing processes, and driving consistent revenue growth.',
    features: [
      'Fractional sales leaders embedded',
      'Sales strategy and process optimization',
      'Team development and coaching',
      'Pipeline management and forecasting'
    ]
  }
];
